import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=25af7f2c&scoped=true&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=25af7f2c&prod&lang=scss&scoped=true&"
import style1 from "./aside.vue?vue&type=style&index=1&id=25af7f2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af7f2c",
  null
  
)

export default component.exports